// extracted by mini-css-extract-plugin
export default {"linkList":"LinkList_linkList__yrmtB","linkListItem":"LinkList_linkListItem__AXMVk","url":"LinkList_url__ZGh6L"};